import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Keeps a product details group in step with the selected variant. The
 * accordion sits outside `<variant-picker>`'s morph target, so this replaces
 * the group from the product-select response, matched by `data-group` and an
 * optional `data-block-id` for independently configured copies.
 */
class SolsticeFrameDetails extends Component {
  #section;
  #generation = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#generation++;
  }

  /**
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const generation = ++this.#generation;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html || !this.isConnected || generation !== this.#generation) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        let selector = `solstice-frame-details[data-group="${CSS.escape(this.dataset.group ?? '')}"]`;
        if (this.dataset.blockId) selector += `[data-block-id="${CSS.escape(this.dataset.blockId)}"]`;
        const next = html.querySelector(selector);
        if (!next) return;

        this.toggleAttribute('data-empty', next.hasAttribute('data-empty'));
        morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn('[solstice-frame-details] Event promise rejected:', error);
        }
      });
  };
}

if (!customElements.get('solstice-frame-details')) {
  customElements.define('solstice-frame-details', SolsticeFrameDetails);
}
